/**
 * i18n reducer
 * Passes along Locale and Messages. We keep an i18n.json file that we use
 * for defining locale specific strings on the client, but eventually we want
 * to be getting the messages and locale from the server. Also we're currently
 * using navigator.language to determine the user's location, which is prone to error,
 * so this should eventually come from a server saved setting.
 *
 * @module reducers/Player
 */

import * as Constants from '../constants';
import { Map } from '../lib/ImmutableUtils';
import { createReducer } from '../lib/ReducerUtils';
import { navigator } from '../tools/Globals';

const defaultTranslations = Constants.i18n.defaultTranslations;

const INITIAL_STATE = Map({
  [Constants.i18n.stateKeys.LOCALE]:
    defaultTranslations.locale as keyof typeof defaultTranslations.messages,
  [Constants.i18n.stateKeys.MESSAGES]: Map<
    Record<keyof typeof defaultTranslations.messages, $TSFixMe>
  >(
    // @ts-expect-error
    defaultTranslations.messages[defaultTranslations.locale],
  ),
});
export type I18nState = typeof INITIAL_STATE;

export default createReducer(INITIAL_STATE, {
  [Constants.App.AppActions.APPLICATION_INITIALIZE]: setLocale,
});

function setLocale(state: I18nState): I18nState {
  const language = navigator.language;
  const locale = language || state.get(Constants.i18n.stateKeys.LOCALE);
  return state.merge({
    [Constants.i18n.stateKeys.LOCALE]: locale,
    // @ts-expect-error
    [Constants.i18n.stateKeys.MESSAGES]: defaultTranslations.messages[locale] || {},
  });
}
